import * as React from 'react'
import * as ReactGA from 'react-ga'
import { Suspense } from 'react'
import { NotFoundBoundary, Router, View } from 'react-navi'
import routes from './routes'

import { StartModal } from './components/common/modal/modal'

import { Api } from './utils/config'
import { Http } from './utils/http'
import { Cookie } from './utils/cookie'

class App extends React.Component {
    public componentWillMount = async () => {
        await this.checkToken()
        this.initGA()
    }

    public render() {
        return (
            <Router routes={routes}>
                <Suspense fallback={null}>
                    <StartModal />
                    <NotFoundBoundary render={() => <h1>Quote Not Found</h1>}>
                        <View />
                    </NotFoundBoundary>
                </Suspense>
            </Router>
        )
    }

    // 初始化ga统计代码
    private initGA() {
        ReactGA.initialize(Api().ga_tracking_id)
    }

    private checkToken = async () => {
        const token = Cookie.get()
        if (token) {
            const url = Api().host + '/usercenter/user_info?auth_token=' + token
            const data = await Http.get(url)
            if (data.code) {
                Cookie.set('')
                window.location.reload()
            }
        }
    }
}

export default App


// WEBPACK FOOTER //
// ./src/App.tsx